import { AudienceBasicFragment, LocationFragment } from '@occc/graphql';
import {
  ConstraintSupplementalData,
  LocationGroupBasic,
  OfferBasic,
  ProductGroupBasic,
  SubBrandBasic,
} from './component-details.types';

type BuildConstraintSupplementalDataParams = {
  campaignId: string;
  audiencesForConstraints?: AudienceBasicFragment[];
  productGroups?: ProductGroupBasic[];
  storeLocationsData?: LocationFragment[];
  storeLocationGroupsData?: LocationGroupBasic[];
  voucheredOffersData?: OfferBasic[];
  subBrandsForConstraints?: SubBrandBasic[];
};

export const buildConstraintSupplementalData = (
  params: BuildConstraintSupplementalDataParams,
): ConstraintSupplementalData => {
  const {
    campaignId,
    audiencesForConstraints,
    productGroups,
    storeLocationsData,
    storeLocationGroupsData,
    voucheredOffersData,
    subBrandsForConstraints,
  } = params;

  const result: ConstraintSupplementalData = { campaignId };

  if (audiencesForConstraints?.length) {
    result.ConstraintInAudience = audiencesForConstraints.reduce<
      Record<string, AudienceBasicFragment>
    >((accumulator, audience) => {
      accumulator[audience.uuid] = audience;
      return accumulator;
    }, {});
  }

  if (productGroups?.length) {
    result.ConstraintPurchaseThreshold = productGroups.reduce<Record<string, ProductGroupBasic>>(
      (accumulator, productGroup) => {
        accumulator[productGroup.id] = { id: productGroup.id, name: productGroup.name };
        return accumulator;
      },
      {},
    );
  }

  if (storeLocationsData?.length) {
    result.ConstraintStoreLocation = storeLocationsData.reduce<Record<string, LocationFragment>>(
      (accumulator, location) => {
        accumulator[location.uuid] = location;
        return accumulator;
      },
      {},
    );
  }

  if (storeLocationGroupsData?.length) {
    result.ConstraintStoreLocationGroup = storeLocationGroupsData.reduce<
      Record<string, LocationGroupBasic>
    >((accumulator, locationGroup) => {
      accumulator[locationGroup.uuid] = { uuid: locationGroup.uuid, name: locationGroup.name };
      return accumulator;
    }, {});
  }

  if (voucheredOffersData?.length) {
    result.ConstraintPurchasableEligibility = voucheredOffersData.reduce<
      Record<string, OfferBasic>
    >((accumulator, offer) => {
      accumulator[offer.id] = { id: offer.id, name: offer.name };
      return accumulator;
    }, {});
  }

  if (subBrandsForConstraints?.length) {
    result.ConstraintSubBrand = subBrandsForConstraints.reduce<Record<string, SubBrandBasic>>(
      (accumulator, subBrand) => {
        accumulator[subBrand.uuid] = { uuid: subBrand.uuid, name: subBrand.name };
        return accumulator;
      },
      {},
    );
  }

  return result;
};
